import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/node/app/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ImageCard = makeShortcode("ImageCard");
const Caption = makeShortcode("Caption");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`I love crafting interactive fiction. It’s the perfect mix of coding and story.`}</p>
      <p>{`And in my most recent projects, I’m exploring how to craft games that help you learn real information while still actually being fun.`}</p>
    </PageDescription>
    <h2>{`The Vaccine Show!`}</h2>
    <Row mdxType="Row">
  <Column colMd={8} colLg={8} mdxType="Column">
    <ImageCard hoverColor="light" titleColor="light" subTitleColor="light" iconColor="light" actionIcon="launch" aspectRatio="2:1" href="/" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1104px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "50%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAACaElEQVQoz2OQ5DCT4DBT5rHxVvAy5Y7VZ4x14E3xFs5wE6jMlZ/carCpWLEzWqbWnrnKhCtGiyPQU8FLW8hGnN1cksOMQZLTVJTFRpbDMVU5P15gcbztFF+VthCDDm+LKWl2y+cVHe7ynxyjPS3RZpqzcp4H86Q0qXolXhshBmuQZgEmi1wL3X5TnQB+x8lm7ttzsqP1versvOdnJJd5RG8sDV0QZj0nwH1tbnS7pdtCN492S5saI7f2IH0xFjMGETYLH3nTPX4yRz0Vr4aK3cmQWGUptC9AcoGVypFQsTVOipvspW5nSl7LkLoUJnK/RPZxnPR03eBwfRtJNlMGaU5TGVbPBg23mzlKp/ylTyapnwuTPR6pvMVLY5+3zPYI3X1ucudTlY75yFwp0rlRpHEvVzlHxk2G1UeKw5RBlNXUXtY9QjS2xjJgoZ3t9QSZSz6SB+wkjgbJ73eXfVCufjlW9mKI9OUIxfPhEsej9SY5eSbIJrjLBYqxmTJIcphJs9nq83l5i9cvsPf4WK9yO13mTLzCuXTls5kq3ZoqNyvVrmUp3C1UvpkmtS/QME6y3EgwSJrNChRg4uxmKnzmLXbhPmzTi2RsLmVpHk60Wuagu8JZc6ub7PEE9c1eGociDTb5mp5P1Jqrp+7P1t1uk2UsaSzCYs4AiWdb0SBjvvAEubxk2Yl+mjW+2m1hJpWBusXZXvUVUb1emuX+evnRcu0lSp2m/KHWwmFyPCYS7GYgzSD9rHZmovYLwn0tOVMt2DNdhLL9JHNDRZrDJVp8RUrNOVMseCP0WRKn+oUEqDuLMTlKcYJ0AQBSMLhkP4p/uwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "The Vaccine Show",
              "title": "The Vaccine Show",
              "src": "/static/dbbd30897d9518fb40bbdf0178cc4717/242c1/vaccine_show_featured.png",
              "srcSet": ["/static/dbbd30897d9518fb40bbdf0178cc4717/7fc1e/vaccine_show_featured.png 288w", "/static/dbbd30897d9518fb40bbdf0178cc4717/a5df1/vaccine_show_featured.png 576w", "/static/dbbd30897d9518fb40bbdf0178cc4717/242c1/vaccine_show_featured.png 1104w"],
              "sizes": "(max-width: 1104px) 100vw, 1104px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ImageCard>
        <Caption fullWidth mdxType="Caption">
For the motivation and data analysis behind this game, see <a href="https://data.billalive.com/21b18-covid-risks/">"Your Real Odds of Dying from COVID-19"</a>.
        </Caption>
  </Column>
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard aspectRatio="1:1" title="Explore the hard data of COVID-19 risks and the case for vaccines in a quirky, nonjudgmental game." href="https://vaccineshow.billalive.com" mdxType="ResourceCard">
          <img {...{
            "src": "https://img.shields.io/badge/r-%23276DC3.svg?style=for-the-badge&logo=r&logoColor=white",
            "alt": "R"
          }}></img>
        </ResourceCard>
  </Column>
    </Row>
    <h2>{`Palace Amnesia`}</h2>
    <Row mdxType="Row">
  <Column colMd={8} colLg={8} mdxType="Column">
    <ImageCard hoverColor="light" titleColor="light" subTitleColor="light" iconColor="light" actionIcon="" aspectRatio="2:1" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "50%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsSAAALEgHS3X78AAABUUlEQVQoz4WRy0rDQBSG+yhSbZtkMpPERGObNJmZTC6NvcVYoxRBS71sxLoRxOhCuimoCxeCL+Ab+H4SU4poL/BzGJjzzWG+UwCQ5hGRAyUGJYYkJisMyQzJ7k/Nkl9BiYmIzpDC7DR9AlIe0LUyKfGYE2xOwDywBYD/tM2BRUg5QHSNXXaCptu2SEJYYpKkZsUiclbAENFiGXfD3a+nzuuAvQyj9LCV9uOrpichvGoyoqUK7jjBsV8/dap3oZ52zYcDd2jtFDcMYQmckQJxjeBt0B73w+ezvft+fBs51yEbNf2blmdW3YpA5guDiK5zJCLuZ9p9vwg+zv3JSXvcs0e+/djzJknN0KyykHlZYBs5OjB0VCXbVh0nmPZMHDPvqG7vm1bE8TZAi/8MIOVEWgFZ1K3GptZQVF/RAkX1ZdUX0VJh+bbE6bbxrxAekP+2vwFboYsiD3OTWQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Palace Amnesia",
              "title": "Palace Amnesia",
              "src": "/static/11b64caa848c35e446680833cd85fbc7/3cbba/palace-amnesia-featured.png",
              "srcSet": ["/static/11b64caa848c35e446680833cd85fbc7/7fc1e/palace-amnesia-featured.png 288w", "/static/11b64caa848c35e446680833cd85fbc7/a5df1/palace-amnesia-featured.png 576w", "/static/11b64caa848c35e446680833cd85fbc7/3cbba/palace-amnesia-featured.png 1152w", "/static/11b64caa848c35e446680833cd85fbc7/0b124/palace-amnesia-featured.png 1728w", "/static/11b64caa848c35e446680833cd85fbc7/6911d/palace-amnesia-featured.png 1750w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ImageCard>
        <Caption fullWidth mdxType="Caption">
For more on my memory research and writing, see <a href="/nonfiction/memory-improvement">Memory Improvement</a>.
        </Caption>
  </Column>
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard aspectRatio="1:1" title="Learn memory techniques by exploring a surreal memory palace." actionIcon="" mdxType="ResourceCard">
          <img {...{
            "src": "https://img.shields.io/badge/perl-%2339457E.svg?style=for-the-badge&logo=perl&logoColor=white",
            "alt": "Perl"
          }}></img>
          <em>&nbsp;&nbsp;(In development.)</em>
        </ResourceCard>
  </Column>
    </Row>
    <h2>{`Packrat`}</h2>
    <Row mdxType="Row">
  <Column colMd={8} colLg={8} mdxType="Column">
    <ImageCard hoverColor="light" titleColor="light" subTitleColor="light" iconColor="light" actionIcon="launch" aspectRatio="2:1" href="https://www.ifwiki.org/Packrat" mdxType="ImageCard">
          <img {...{
            "src": "https://picsum.photos/id/1040/1200/600",
            "alt": "Packrat"
          }}></img>
        </ImageCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard aspectRatio="1:1" title="You have one job: wake the Princess. But this castle is chock full of sleeping nobles and unguarded loot..." href="https://www.ifwiki.org/Packrat" mdxType="ResourceCard">
        </ResourceCard>
  </Column>
    </Row>
    <h2>{`MANALIVE, A Mystery of Madness`}</h2>
    <Row mdxType="Row">
  <Column colMd={8} colLg={8} mdxType="Column">
    <ImageCard hoverColor="light" titleColor="light" subTitleColor="light" iconColor="light" actionIcon="launch" aspectRatio="2:1" href="https://www.ifwiki.org/MANALIVE,_A_Mystery_of_Madness_-_I" mdxType="ImageCard">
          <img {...{
            "src": "https://picsum.photos/id/1064/1200/600",
            "alt": "MANALIVE"
          }}></img>
        </ImageCard>
        <Caption fullWidth mdxType="Caption">
Winner of the IF Comp <a href="https://www.ifwiki.org/Golden_Banana_of_Discord">Golden Banana of Discord</a>.
        </Caption>
  </Column>
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard aspectRatio="1:1" title="A man accused of grand theft, deserting his family, and even murder may hide a secret more shocking than any of his crimes." href="https://www.ifwiki.org/MANALIVE,_A_Mystery_of_Madness_-_I" mdxType="ResourceCard">
        </ResourceCard>
  </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      